import ColdKeeperIcon from './ColdKeeperIcon';

export default ColdKeeperIcon;
